//
// Constantes de permisos disponibles
//

export class Roles {
    public static Admin = 'Admin';
    public static EntityUser = 'EntityUser';
    public static ExpertUser = 'ExpertUser';

    public static GuessCollaborativeArea = 'GuessCollaborativeArea';
    public static CollaboratorCollaborativeArea = 'CollaboratorCollaborativeArea';
    public static OwnerCollaborativeArea = 'OwnerCollaborativeArea';
}
